import { getAxiosInstance } from "../../../api";

export const saveDrumBall = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/drumball/save`, body);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const passAll = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(
      `/employee-dashboard/order/bulk-status-complete`,
      params,
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};
